import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './DocCenterContent.css';

interface DocCenterContentProps {
    cls: string;

    text: string;
}

function toggleCut(cut: HTMLElement | null) {
    if (cut === null) {
        return;
    }
    const content = cut.nextSibling as Element;
    if (
        content &&
        content.classList.contains(
            Bem.cls({ block: 'doc-c-cut', elem: 'content' })
        )
    ) {
        content.classList.toggle(
            Bem.cls({ block: 'doc-c-cut', elem: 'content-visible' })
        );
    }
}

export class DocCenterContent extends React.PureComponent<
    DocCenterContentProps
> {
    render() {
        const { cls, text } = this.props;
        return (
            <div className={classNames(Bem.cls('doccenter-content'), cls)}>
                <div
                    className={Bem.cls('doccenter-content', 'text')}
                    onClick={this.onClick}
                    dangerouslySetInnerHTML={{ __html: text }}
                />
            </div>
        );
    }

    /**
     * Специальный метод для реализации "ката" в хэлпе
     * Смотрит на target клика, и если он "катовый" - дергает перерисовку
     * @param {React.MouseEvent<HTMLElement>} e
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) => {
        const target = e.target as Element;

        if (target === null) {
            return;
        }

        if (target.classList.contains(Bem.cls('doc-c-cut', 'inner'))) {
            toggleCut(target.parentElement);
        }
    };
}
